import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import React from "react";
import reactStringReplace from "react-string-replace";
import { STRINGS } from "../strings";
import { AppCaregiver } from "../system/AppState/AppCaregiverState";
import { translate } from "../translate";
import AnimatedModal from "./AnimatedModal";
import { AppButton } from "./Generic/AppButton";
import Flex from "./Generic/Flex";
import { default as WomanJumpsVector } from "/public/assets/woman-jumps.svg?react";

interface Props {
  caregiver: Pick<AppCaregiver, "firstName">;
  isOpen: boolean;
  onClickNext: () => void;
  onRequestClose: () => void;
}

const FinishOnboardingModal = (props: Props) => {
  const title = translate(STRINGS.FINISH_ONBOARDING_MODAL_TITLE).replace(
    "%name%",
    props.caregiver.firstName
  );

  const message = (
    <FinishOnboardingModal.P>
      {reactStringReplace(translate(STRINGS.FINISH_ONBOARDING_MODAL_MESSAGE), /\$/, () => (
        <strong key="1">$150!</strong>
      ))}
    </FinishOnboardingModal.P>
  );

  const actions = (
    <>
      <AppButton size="large" variant="filled" color="sexy" onClick={props.onClickNext}>
        {translate(STRINGS.FINISH_MY_ONBOARDING)}
      </AppButton>
    </>
  );

  return (
    <AnimatedModal
      headline={title}
      message={message}
      animation={<FinishOnboardingModal.AnimatedVector />}
      animationOffset={100}
      actions={actions}
      isOpen={props.isOpen}
      onRequestClose={props.onRequestClose}
    />
  );
};

FinishOnboardingModal.Stage2 = (props: Props) => {
  const title = translate(STRINGS.FINISH_ONBOARDING_MODAL_TITLE_STAGE_2);

  const message = (
    <FinishOnboardingModal.P>
      {translate(STRINGS.FINISH_ONBOARDING_MODAL_MESSAGE_STAGE_2)}
    </FinishOnboardingModal.P>
  );

  const actions = (
    <Flex direction="column" yGap={6}>
      <AppButton variant="filled" color="sexy" onClick={props.onRequestClose}>
        {translate(STRINGS.LETS_FIND_CASES)}
      </AppButton>
      <AppButton variant="soft" color="primary" onClick={props.onClickNext}>
        {translate(STRINGS.FINISH_THE_DOCUMENTS)}
      </AppButton>
    </Flex>
  );

  return (
    <AnimatedModal
      headline={title}
      message={message}
      animation={<FinishOnboardingModal.AnimatedVector />}
      animationOffset={100}
      actions={actions}
      isOpen={props.isOpen}
      onRequestClose={props.onRequestClose}
    />
  );
};

const personKeyframes = keyframes`
    from {
        transform: scale(0.9) translateY(100px);
    }
`;

FinishOnboardingModal.AnimatedVector = styled(WomanJumpsVector)`
  g[data-entity="person"] {
    animation: ${personKeyframes} 0.75s cubic-bezier(0, -0.25, 0, 1.24);
    transform-origin: center;
  }
`;

FinishOnboardingModal.P = styled.p`
  font-weight: 600;
  font-size: 18px;
  line-height: 140%;
  color: var(--gray-700);

  > strong {
    color: black;
    font-weight: 800;
  }
`;

export default FinishOnboardingModal;
